import { List } from 'immutable';
import QuizSessionResult from '../records/QuizSessionResult';
export function getQuizSessionResultsByIds(state) {
  var ids = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  return ids.reduce(function (list, id) {
    var sessionItem = getQuizSessionResultById(state, id);
    return sessionItem ? list.push(sessionItem) : list;
  }, List());
}
export function getQuizSessionResultById(state, id) {
  return QuizSessionResult.create(state.getIn(['quizSessionResults', id]));
}